import { Component, ViewChild } from '@angular/core';
import { Platform, NavController, App, IonicApp } from 'ionic-angular';


//import { CardsPage } from '../pages/cards/cards';
//import { ContentPage } from '../pages/content/content';
//import { FirstRunPage } from '../pages/pages';
//import { MainPage } from '../pages/main-page/main-page';
//import { LoginPage } from '../pages/login/login';
//import { MenuPage } from '../pages/menu/menu';
//import { SearchPage } from '../pages/search/search';
//import { SettingsPage } from '../pages/settings/settings';
//import { SignupPage } from '../pages/signup/signup';
//import { TabsPage } from '../pages/tabs/tabs';
// import { TutorialPage } from '../pages/tutorial/tutorial';
// import { WelcomePage } from '../pages/welcome/welcome';
// import { SchedulePage } from '../pages/schedule/schedule';
// import { EmailPage } from '../pages/email/email';
// import { ClientPage } from '../pages/client/client';
// import { ClientCreatePage } from '../pages/client-create/client-create';
// import { SelectAssessmentPage } from '../pages/select-assessment/select-assessment';
// import { AdministerPage } from '../pages/administer/administer';
// import { AssessmentReportPage } from '../pages/assessment-report/assessment-report';
// import { AddNotePage } from '../pages/add-note/add-note';
// import { AlertPage } from '../pages/alert/alert';
// import { ScheduleAlertPage } from '../pages/schedule-alert/schedule-alert';
// import { TestQuestionsPage } from '../pages/test-questions/test-questions';

// import { Settings } from '../providers/providers';

import { TranslateService } from '@ngx-translate/core'

@Component({
  template: `
  // <ion-menu [content]="content">
  //   <ion-header>
  //     <ion-toolbar>
  //       <ion-title>Pages</ion-title>
  //     </ion-toolbar>
  //   </ion-header>

  //   <ion-content>
  //     <ion-list>
  //       <button menuClose ion-item *ngFor="let p of pages" (click)="openPage(p)">
  //         {{p.title}}
  //       </button>
  //     </ion-list>
  //   </ion-content>

  // </ion-menu>
  <ion-nav #content [root]="rootPage"></ion-nav>`
})
export class MyApp {
  // rootPage = FirstRunPage;
  rootPage: string = 'login';

  @ViewChild('content') nav: NavController;

  // pages: any[] = [
  //   { title: 'Tutorial', component: TutorialPage },
  //   { title: 'Welcome', component: WelcomePage },
  //   { title: 'Tabs', component: TabsPage },
  //   { title: 'Cards', component: CardsPage },
  //   { title: 'Content', component: ContentPage },
  //   { title: 'Login', component: LoginPage },
  //   { title: 'Signup', component: SignupPage },
  //   //{ title: 'Main Page', component: MainPage },
  //   { title: 'Menu', component: MenuPage },
  //   { title: 'Schedule', component: SchedulePage },
  //   { title: 'Email', component: EmailPage },
  //   { title: 'Client', component: ClientPage },
  //   { title: 'Create Client', component: ClientCreatePage },
  //   { title: 'Select Assessment', component: SelectAssessmentPage },
  //   { title: 'Administer', component: AdministerPage },
  //   { title: 'Assessment Report', component: AssessmentReportPage },
  //   { title: 'Add Note', component: AddNotePage },
  //   { title: 'Alert', component: AlertPage },
  //   { title: 'Schedule Alert', component: ScheduleAlertPage},
  //   { title: 'Questions', component: TestQuestionsPage },
  // ]

  constructor(private translate: TranslateService, private platform: Platform,private _app: App, private _ionicApp: IonicApp) {
    this.initTranslate();
    platform.ready().then(() => {
      this.setupBackButtonBehavior();
    });
    //this.setupBackButtonBehavior();
  }

  private setupBackButtonBehavior () {
    // If on web version (browser)
    if (window.location.protocol !== "file:") {

      // Register browser back button action(s)
      window.onpopstate = (evt) => {

        // Close any active modals or overlays
        let activePortal = this._ionicApp._loadingPortal.getActive() ||
          this._ionicApp._modalPortal.getActive() ||
          this._ionicApp._toastPortal.getActive() ||
          this._ionicApp._overlayPortal.getActive();

        if (activePortal) {
          activePortal.dismiss();
          return;
        }
        
        let nav = this._app.getActiveNavs()[0];
        let activeView = nav.getActive();
          // if (activeView.id === 'test-questions' || activeView.data.pageName == 'administer' || (activeView.id === 'administer' && activeView.data.pageId == 'administer')) {
            if (activeView.id === 'test-questions' || activeView.id == 'administer' || activeView.id === 'assessment-complete') {
            if (nav.canGoBack()) {
              localStorage.clear();
              this.nav.setRoot('login');
            } 
          } else {
            if (nav.canGoBack()) {
              //nav.pop();//do nothing
            }
            
          }
        

      }

      // Navigate back
      // if (this._app.getRootNav().canGoBack()) 
      // // this._app.getRootNav().pop();
      // localStorage.clear();
      // this._app.getRootNav().popToRoot()

    };

      // Fake browser history on each view enter
      // this._app.viewDidEnter.subscribe((app) => {
      //   history.pushState (null, null, "");
      // });

    }

  ionViewDidLoad() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
    });
  }

  initTranslate() {
    // Set the default language for translation strings, and the current language.
    this.translate.setDefaultLang('en');

    if (this.translate.getBrowserLang() !== undefined) {
      this.translate.use(this.translate.getBrowserLang());
    } else {
      this.translate.use('en'); // Set your language here
    }

    
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts